import React from 'react';
import { Shield, Users, Eye, Heart } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { CollapsibleSection } from './CollapsibleSection';

export const TrustBlock = ({ isOpen, onToggle }) => {
  const { t } = useLanguage();

  const trustPoints = [
    {
      icon: <Shield className="w-5 h-5" />,
      title: t('trust1Title'),
      description: t('trust1Desc'),
      color: 'from-fuchsia-500 to-pink-500'
    },
    {
      icon: <Users className="w-5 h-5" />,
      title: t('trust2Title'),
      description: t('trust2Desc'),
      color: 'from-cyan-500 to-blue-500'
    },
    {
      icon: <Eye className="w-5 h-5" />,
      title: t('trust3Title'),
      description: t('trust3Desc'),
      color: 'from-pink-500 to-purple-500'
    },
    {
      icon: <Heart className="w-5 h-5" />,
      title: t('trust4Title'),
      description: t('trust4Desc'),
      color: 'from-emerald-500 to-cyan-500'
    }
  ];

  return (
    <CollapsibleSection
      id="trust-section"
      eyebrow={t('trustLabel')}
      title={t('trustHeading')}
      isOpen={isOpen}
      onToggle={onToggle}
      testId="trust-block-toggle"
    >
      <div className="grid gap-6 md:grid-cols-2">
        {trustPoints.map((point, index) => (
          <div
            key={index}
            className="group rounded-2xl p-6 bg-slate-900/40 backdrop-blur-sm border border-slate-700/50 hover:border-slate-600/50 hover:bg-slate-900/60 transition-all duration-300 hover:scale-105"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${point.color} p-2.5 text-white shadow-lg flex items-center justify-center flex-shrink-0`}>
                {point.icon}
              </div>
              <div>
                <h3 className="text-base font-bold text-white mb-2">{point.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{point.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </CollapsibleSection>
  );
};
